import { render, staticRenderFns } from "./DateColumn.vue?vue&type=template&id=28993757&"
import script from "./DateColumn.vue?vue&type=script&lang=js&"
export * from "./DateColumn.vue?vue&type=script&lang=js&"
import style0 from "./DateColumn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28993757')) {
      api.createRecord('28993757', component.options)
    } else {
      api.reload('28993757', component.options)
    }
    module.hot.accept("./DateColumn.vue?vue&type=template&id=28993757&", function () {
      api.rerender('28993757', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/table/DateColumn.vue"
export default component.exports